'use client';

import { createContext } from 'react';

// Slides from the /fit-guide CMS page, or a promise of them
const FitGuideSlidesContext = createContext(null);

export default FitGuideSlidesContext;
